import { FinanceDetailsQuestions } from './questions';
import { fixPrecision } from '../../../common/helpers';
import { IUpdateFinancingAmountErrorOptions } from './types';

export const countFtvValue = (deposit: number, financingAmount: number): number => {
  if (!financingAmount || financingAmount < 0 || !deposit || deposit < 0) {
    return FinanceDetailsQuestions.ftv.defaultValue;
  }

  return fixPrecision((financingAmount / (financingAmount + deposit)) * 100);
};

export const checkValueWithinRangeAndReturnErrorId = (
  value: '' | number | null,
  min: number,
  max: number,
): string | null => {
  if (value === null && value === '') {
    return null;
  }

  value = value && Number(value);

  if (typeof value === 'number' && !isNaN(value)) {
    if (value < min) {
      return 'affordabilityCalculator.common.minError';
    }

    if (value > max) {
      return 'affordabilityCalculator.common.maxError';
    }
  }

  return null;
};

export function extractFinancingAmountUpperLimitByFtv(ftv: number | null): number {
  const { maxProfile } = FinanceDetailsQuestions.financeAmount;
  let currentMaxAmount = getDefaultMaxFinanceAmount();

  if (!ftv) {
    return currentMaxAmount;
  }

  Object.keys(maxProfile).forEach((key: unknown) => {
    const amount = Number(key) as keyof typeof maxProfile;
    const currentMaxProfile = maxProfile[amount];

    if (ftv >= currentMaxProfile.minFtvInclusive && ftv <= currentMaxProfile.maxFtvInclusive) {
      currentMaxAmount = amount;
    }
  });

  return currentMaxAmount;
}

export const updateFinancingAmountErrorOnFtvChange = (
  ftv: number,
  financingAmount: number | null,
  options: IUpdateFinancingAmountErrorOptions,
) => {
  const { form, intl } = options;

  const min = FinanceDetailsQuestions.financeAmount.min;
  const max = extractFinancingAmountUpperLimitByFtv(ftv);
  const errorId = checkValueWithinRangeAndReturnErrorId(financingAmount, min, max);

  updateFinancingAmountError(errorId, { form, intl });
};

export function updateFinancingAmountError(errorId: string | null, options: IUpdateFinancingAmountErrorOptions): void {
  const { form, intl } = options;

  if (!errorId) {
    return form.clearErrors('financeDetails.financingAmount');
  }

  form.setError('financeDetails.financingAmount', { message: intl.formatMessage({ id: errorId }) });
}

export function getDefaultMaxFinanceAmount() {
  const { maxProfile } = FinanceDetailsQuestions.financeAmount;

  return Math.max(...Object.keys(maxProfile).map(key => Number(key)));
}
